<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <!-- Page Content -->
      <div class="content mt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <!-- Account Content -->
              <div class="account-content">
                <div style="display: flex; flex-direction: row;">
                  <div class="col-md-7 col-lg-6 mr-5 login-left">
                    <img :src="'https://app.bhilwarahealthcare.in' + loginPageImage" class="img-fluid" alt="Login Banner"
                      style="height: 370px; border-radius: 15px;" />

                  </div>
                  <div class="col-md-12 col-lg-5 login-right">
                    <div class="login-header">
                      <h3 class="mt-2">Login to {{ main_data }}</h3>
                    </div>

                    <!-- Forgot Password Form -->

                    <div class="form-group form-focus" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 45px; border-radius: 4px 0 0 4px; z-index: 2;">
                        +91
                      </button>
                      <input maxlength="10" @keypress="onlyNumber" @keydown.enter="sendOtpOnEnter" v-model="mobile_no"
                        class="form-control floating inputPrice"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; width:100%; max-width: 450px; height: 45px; letter-spacing: 6px;"
                        placeholder="Mobile No" />
                    </div>

                    <button ref="sendOtpButton" class="btn btn-primary btn-block btn-lg login-btn" type="submit"
                      :disabled="!mobile_no.match('[0-9]{10}')" @click="send_otp()">
                      Send OTP
                    </button>

                    <div class="dont-have" style="text-align: left;">
                      Don’t have an account?
                      <a @click="navigateToSignup()" href="javascript:void(0)">Register</a>
                    </div>
                    <!-- /Forgot Password Form -->
                  </div>
                </div>
              </div>
              <!-- /Account Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      mobile_no: "",
      main_data: "",
      loginPageImage: "",
      hospital: "",
      domain_for: "",
      Country:""
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {
    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    sendOtpOnEnter() {
      // This method will be called when Enter key is pressed in the input field
      if (this.mobile_no.match("[0-9]{10}")) {
        // If the mobile number is valid, simulate a click on the "Send OTP" button
        this.$refs.sendOtpButton.click();
      }
    },

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].header;
            this.loginPageImage = res.data.data[0].login_page;
            this.apiResponse = res.data; // Store the API response
            this.domain_for = res.data.data[0].domain_for;
            this.hospital = res.data.data[0].hospital;
            this.country = res.data.data[0].country;
            
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }

          this.$swal.close();
        });
    },

    navigateToSignup() {
      // Now you can use this.apiResponse to access the API response data
      if (this.apiResponse && this.apiResponse.data && this.apiResponse.data.length > 0) {
        const domainFor = this.apiResponse.data[0].domain_for;

        // Check the value of 'domain_for'
        if (domainFor === "Hospital Portal") {
          this.$router.push("/patient/register"); // Navigate to /patient/register
        } else {
          this.$router.push("/doctor/register"); // Navigate to /doctor/register
        }
      }
    },
    send_otp() {
  if (this.mobile_no) {
    this.$swal({
      text: "Sending OTP...",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });

    var apiEndpoint = "";
    
    // Check the value of 'domain_for'
    if (this.domain_for === "Hospital Portal" || this.domain_for === "Country Portal") {
      apiEndpoint = "sahaj.api.send_otp_registered_user_new";
    } else {
      apiEndpoint = "sahaj.api.send_otp_registered_user";
    }

    var bodyFormData = new FormData();
    bodyFormData.append("phone", this.mobile_no);

    // Include 'hospital' parameter only if 'domain_for' is "Hospital Portal"
    if (this.domain_for === "Hospital Portal") {
      bodyFormData.append("hospital", this.hospital);
    }else if(this.domain_for === "Country Portal"){
      bodyFormData.append("country",this.country);
    }

    CommonApi.post_data(apiEndpoint, bodyFormData, true).then((res) => {
      if (res.status_code === 200) {
        this.$router.push({
          name: "enter-OTP",
          params: { mobile: this.mobile_no },
        });
        this.$swal.close();
      } else {
        this.$swal.fire({
          icon: "warning",
          title: "Warning",
          text: res.message,
          showConfirmButton: true,
        });
      }
    });
  }
},


  },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/LoginWithOTP.vue